import { lazyLoadWithRetry } from "utilities/react.utilities";
import { routes } from "utilities/routes";

import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { type IExistingOwnerInvoiceSelectProps } from "commonComponents/entity/invoicing/ExistingOwnerInvoiceSelect/ExistingOwnerInvoiceSelect";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

const ExistingOwnerInvoiceSelect = lazyLoadWithRetry(() => import("./ExistingOwnerInvoiceSelect"));

export interface IRouteExistingOwnerInvoiceSelectProps<ActionType>
    extends Omit<IExistingOwnerInvoiceSelectProps<ActionType>, "history" | "location" | "match"> {}
export const RouteExistingOwnerInvoiceSelect: React.FunctionComponent<
    IRouteExistingOwnerInvoiceSelectProps<any>
> = (props) => (
    <RouteRelative
        path={routes.existingOwnerInvoiceSelect.path}
        render={(routeProps) => {
            return (
                <BTSuspense>
                    <ExistingOwnerInvoiceSelect
                        {...props}
                        {...routeProps}
                        beforeClose={() => {
                            props.beforeClose();
                        }}
                    />
                </BTSuspense>
            );
        }}
    />
);
